import axios from 'axios'
import { api } from "@config"
import { clearAllCookies, getCookieByName, setCookieByName } from '../utils'
import { showSnackBar } from "../utils"

import { getConfig } from "../utils/config"

const config = getConfig()

const apiURL = config.api.baseUrl

console.debug("API_URL", apiURL)

// Load the enviroments config vars

const API_URL = apiURL
const API_VERSION = process.env.REACT_APP_API_VERSION
const API_ROOT = process.env.REACT_APP_API_ROOT

const baseUrl = `${API_URL}/${API_ROOT}/${API_VERSION}/`
export const baseURL = baseUrl

const instance = axios.create({
    baseURL,
    timeout: 120000,
})
// urls to save on session storage
const URLS_FOR_SAVE_ON_CACHE = ["payment-methods/"]

// the basic requests system
async function refreshToken() {
    return new Promise((resolve, reject) => {
        const refresh = getCookieByName("refresh")
        const data = {
            refresh: refresh
        }
        const url = `${API_URL}/api/token/refresh/`
        axios
            .post(url, data)
            .then(responsse => {
                setCookieByName("access", responsse.data.access)
                resolve(responsse.data.access)
            })
            .catch(error => {
                console.log("ERROR", error)
                if (error.response) {
                    var cookies = document.cookie.split(';');
                    for (var i = 0; i < cookies.length; i++) {
                        document.cookie = `${cookies[i]}=;expires=${new Date(0).toUTCString()}`
                    }
                    window.localStorage.clear()
                    document.cookie = ""
                    window.location.href = ""
                }
                reject(error)
            })
    })
}

instance.interceptors.request.use(config => {
    const access = getCookieByName("access")
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${access}`
    }
    config["headers"] = headers
    return config
}, error => Promise.reject(error))

instance.interceptors.response.use(response => {
    if (URLS_FOR_SAVE_ON_CACHE.includes(response.config.url)) {
        try {
            sessionStorage.setItem(response.config.url, JSON.stringify(response.data))
        } catch (error) { }
    }
    return response.data
}, async error => {
    let token_reloaded = false
    if (error.response) {
        const { status, statusText } = error.response
        if (status === 401 || statusText && statusText === "Unauthorized") {
            await refreshToken()
            token_reloaded = true
        }
    }
    error["token_reloaded"] = token_reloaded
    return Promise.reject(error);
})

function requestError(error, reject) {
    if (error.message) {
        if (error.message === "Network Error") {
            showSnackBar("Falha na comunicação com a rede.")
            reject(error)
            return
        }
    }
    if (error.response) {
        if (error.response.status === 400) {
            reject(error.response.data)
            return
        } else if (error.response.status === 500) {
            reject(error.response.data)
            return
        }
        if(error.response.data){
            if(error.response.data.code === "token_not_valid"){
                const token = localStorage.getItem("easygestorweb_refresh_token")
                const refresh = localStorage.getItem("easygestorweb_apikey")
                if( !token || !refresh ){
                    localStorage.clear()
                    clearAllCookies()
                    location.reload()
                }
            }
        }
        reject(error.response)
    } else {
        reject(error)
    }
}

export function request(data, isBranchUser = true, branchOwnerId = null) {
    if (isBranchUser) {
        if (!data.params) {
            data["params"] = {}
        }
        data["params"]["branch_owner"] = branchOwnerId || getCookieByName("branch_owner_id")
    }

    return new Promise(async (resolve, reject) => {
        if (data.url) {
            if (URLS_FOR_SAVE_ON_CACHE.includes(data.url)) {
                if (sessionStorage.getItem(data.url)) {
                    try {
                        resolve(JSON.parse(sessionStorage.getItem(data.url)))
                        return
                    } catch (error) { }
                }
            }
        }
        instance(data)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                if (error.token_reloaded) {
                    request(data, isBranchUser)
                        .then(result => resolve(result))
                        .catch(error => {
                            requestError(error, reject)
                        })
                } else {
                    requestError(error, reject)
                }
            })
    })
}

export class Request {
    constructor(baseUrl) {
        this.url = baseUrl
    }

    _getCookie(name) {
        const cookies = document.cookie.split(';')
        const cookie = cookies.find(cookie => cookie.includes(name))
        if (cookie) {
            return cookie.split('=')[1]
        } else {
            if (name == "access") {
                window.localStorage.clear()
                window.location.href = "/"
            }
        }
    }

    _updateCookie(cookieName, newValue) {
        const date = new Date();
        date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
        const expires = `expires = ${date.toUTCString()}`
        let newCookies = ""
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i]
            const [name, value] = cookie.split('=')

            if (` ${cookieName} ` === name) {
                newCookies += `${name}=${newValue}; `
                console.log("cookie updated to", newValue)
            } else {
                newCookies += `${name}=${value}; `
            }
        }
        document.cookie = newCookies + expires

    }

    _setCookie(name, value) {
        const date = new Date();
        date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
        const expires = `expires = ${date.toUTCString()} `
        document.cookie = `${name}=${value};${document.cookie}; path = /;${expires}`
    }


    _getAuthorizationToken() {
        const access = this._getCookie('access')
        return `Bearer ${access}`
    }


    _getBranchOwnerId() {
        return this._getCookie('branch_owner_id')
    }

    _request(axiosrequestData) {
        axiosrequestData["headers"] = {
            "Content-Type": "application/json",
        }
        if (axiosrequestData.useAuthHeaders) {
            axiosrequestData["headers"]["Authorization"] = this._getAuthorizationToken()
        }
        if (axiosrequestData.useBranchOwner) {
            if (!axiosrequestData["params"]) {
                axiosrequestData["params"] = {}
            }
            axiosrequestData["params"]["branch_owner"] = this._getBranchOwnerId()
        }

        return new Promise((resolve, reject) => {
            axios.request(axiosrequestData)
                .then(response => {
                    resolve(response.data)
                })
                .catch(err => {
                    if (err.response) {
                        const statusCode = err.response.status
                        switch (statusCode) {
                            case 400:
                                reject(err.response.data)
                                break
                            case 401:
                                const statusText = err.response.statusText
                                const data = err.response.data
                                const code = data.code
                                const reloadToken = statusText === "Unauthorized" && code === 'token_not_valid'
                                const userInactive = false
                                if (reloadToken) {
                                    const refresh = this._getCookie("refresh")
                                    axios.post(`${this.url}/api/token/refresh/`, {
                                        refresh: refresh
                                    })
                                        .then(response => {
                                            this._setCookie("access", response.data.access)
                                            this._request(axiosrequestData)
                                                .then(data => resolve(data))
                                        })
                                        .catch(err => { })
                                }
                                break
                            case 403:
                                reject(err.response)
                                break
                            case 500:
                                reject(err.response.data)
                                break

                        }
                    }
                })
        })
    }

    __request(requestData, useAuthHeaders = true, useBranchOwner = true) {
        requestData["headers"] = {
            "Content-Type": "application/json",
        }
        if (useAuthHeaders) {
            requestData["headers"]["Authorization"] = this._getAuthorizationToken()
        }
        if (useBranchOwner) {
            if (!requestData["params"]) {
                requestData["params"] = {}
            }
            requestData["params"]["branch_owner"] = this._getBranchOwnerId()
        }

        return new Promise((resolve, reject) => {
            console.log("iniciou a promise")
            instance(requestData)
                .then(response => {
                    console.log("deu certo: ", response.data)
                    resolve(response.data)
                })
                .catch(error => {
                    console.log("deu errado", error)
                    if (error.response) {
                        const { status } = error.response
                        if (status === 400) {
                            console.log("deu erro 400", error.response.data)
                            reject(error.response.data)
                        } else if (status === 401) {
                            console.log("status 401")
                            const refresh = this._getCookie("refresh")
                            axios.post(`${API_URL}/api/token/refresh/`, {
                                refresh: refresh
                            })
                                .then(reloadResponse => {
                                    console.log("recarregou", reloadResponse.data)
                                    const { access } = reloadResponse.data
                                    this._setCookie("access", access)
                                    console.log("reinicia a requisição")
                                    this.__request(requestData)
                                })
                        } else if (status === 500) {
                            reject(error.response.data)
                        }
                    }
                })
        })
    }


    get(path, params, useAuthHeaders = true, useBranchOwner = true) {
        const request = {
            url: `${this.url}${path}`,
            method: "GET",
            params: params
        }
        request["useAuthHeaders"] = useAuthHeaders
        request["useBranchOwner"] = useBranchOwner
        return this._request(request)
    }


    post(path, data, params = {}, useAuthHeaders = true, useBranchOwner = true) {
        const request = {
            url: `${this.url}${path}`,
            method: "POST",
            data: data,
            params: params
        }
        request["useAuthHeaders"] = useAuthHeaders
        request["useBranchOwner"] = useBranchOwner
        return this._request(request)
    }


    put(path, data, params = {}, useAuthHeaders = true, useBranchOwner = true) {
        const request = {
            url: `${this.url}${path}`,
            method: "PUT",
            data: data,
            params: params
        }
        request["useAuthHeaders"] = useAuthHeaders
        request["useBranchOwner"] = useBranchOwner
        return this._request(request)
    }

    delete() {
        return axios.delete(this.url)
    }

    showError(message) {
        const divError = document.createElement('div')
        divError.classList.add('.alert-lkhasdk')
        divError.classList.add('error')

        const p = document.createElement('p')
        p.classList.add('body')
        p.innerText = message
        divError.appendChild(p)
    }

}

class API extends Request {
    constructor() {
        super(api.baseUrl)
    }
    auth(email, password) {
        return new Promise((resolve, reject) => {
            const data = { email, password }
            super
                .post('/api/token/', data, {}, false, false)
                .then(response => {
                    super._setCookie('access', response.access)
                    super._setCookie('refresh', response.refresh)

                    window.localStorage.setItem(
                        "easygestorweb_apikey",
                        JSON.stringify(response.access)
                    );
                    window.localStorage.setItem(
                        "easygestorweb_refresh_token",
                        JSON.stringify(response.refresh)
                    );

                    resolve(response.data)
                })
                .catch(err => {
                    console.log(err.request)
                    super.showError("err")
                    reject(err)
                })
        })
    }

    register(data) {
        return new Promise((resolve, reject) => {
            super
                .post('/api/v1/users/', data)
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }

    searchUser(email) {
        return new Promise((resolve, reject) => {
            super
                .post('/api/v1/users/search/', { email: email })
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }

    getUser(id) {
        return new Promise((resolve, reject) => {
            super
                .get(`/api/v1/users/${id}/`, {}, true, true)
                .then(data => {
                    resolve(true)
                    window.localStorage.setItem(
                        "easygestorweb_userdata",
                        JSON.stringify(data)
                    );
                })
                .catch(error => {
                    reject(error)
                })
        })
    }

    getActiveBranch() {
        return new Promise((resolve, reject) => {
            super
                .get('/api/v1/branches/')
                .then(data => {
                    super._setCookie('branch_owner_id', data[0].id)
                    window.localStorage.setItem(
                        "easygestorweb_current_branch",
                        JSON.stringify(data[0])
                    );
                    window.localStorage.setItem(
                        "easygestorweb_all_branches",
                        JSON.stringify(data)
                    );
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }

    getBranch(id) { }

    createBranch() { }

    editBranch() { }

    getPlans() {
        return new Promise((resolve, reject) => {
            super
                .get('/api/v1/plans/')
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    getBranchPlan() {
        return new Promise((resolve, reject) => {
            super
                .get('/api/v1/branch-plans/')
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    upgradePlan(new_plan_id) {
        return new Promise((resolve, reject) => {
            super
                .put('/api/v1/branch-plans/upgrade/', { new_plan_id })
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    createBranchPlan(plan) {
        return new Promise((resolve, reject) => {
            super
                .post('/api/v1/branch-plans/', { plan })
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    getBranchInvoices(params = {}) {
        return new Promise((resolve, reject) => {
            super
                .get('/api/v1/invoices/', params)
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }

    getNotifications() {
        return new Promise((resolve, reject) => {
            super.get('/api/v1/branch-notifications/')
                .then(data => resolve(data.notifications))
                .catch(error => reject(error))
        })
    }
    makeSeenNotifications() {
        return new Promise((resolve, reject) => {
            super.post('/api/v1/branch-notifications/')
                .then(data => resolve(data))
                .catch(error => reject(error))
        })
    }

    getCategories() {
        return new Promise((resolve, reject) => {
            super
                .get('/api/v1/products/categories/')
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }

    createProduct() { }

    getProduct(id) { }

    getProducts(params = {}) {
        return new Promise((resolve, reject) => {
            super
                .get('/api/v1/products/', params)
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    getUnits() {
        return new Promise((resolve, reject) => {
            super
                .get('/api/v1/products/units/')
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    searchCFOP(params = {}) {
        return new Promise((resolve, reject) => {
            super
                .get('/api/v1/products/cfop/', params)
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }

    createClient(data, params = {}) { }
    getClient(id) { }
    getClients(params = {}) {
        return new Promise((resolve, reject) => {
            super
                .get('/api/v1/clients/', params)
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }

    getTransporters() {
        return new Promise((resolve, reject) => {
            super
                .get('/api/v1/nfe-transporter/')
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }

    getPaymentMehtods() {
        return new Promise((resolve, reject) => {
            super
                .get('/api/v1/payment-methods/')
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    getNFeConfig() {
        return new Promise((resolve, reject) => {
            super
                .get('/api/v1/config/')
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    updateConfig(data) {
        return new Promise((resolve, reject) => {
            super
                .put(`/api/v1/config/${data.id}/`, data)
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    listNFe(params = {}) {
        return new Promise((resolve, reject) => {
            super
                .get('/api/v1/nfe/', params)
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    donwloadBase64File(base64, filename, mime) { }

    getNFeBase64(params = {}) {
        return new Promise((resolve, reject) => {
            super
                .get('/api/v1/nfe/download/', params)
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    getNFeBy(id) { }

    verifyNFeStatus(id) {
        return new Promise((resolve, reject) => {
            super
                .post(`/api/v1/nfe/${id}/has-pending/`, { id })
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }

    createNFe(nfe) {
        return new Promise((resolve, reject) => {
            super
                .post('/api/v1/nfe/', nfe)
                .then(data => {
                    resolve(data)
                })
                .catch(error => reject(error))
        })
    }

    NFeHistory(params = {}) {
        return new Promise((resolve, reject) => {
            super
                .get(`/api/v1/nfe/`, params)
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }

    downloadNFe(id, params = { file: "pdf" }) {
        return new Promise((resolve, reject) => {
            super
                .post(`/api/v1/nfe/${id}/download/`, {}, params)
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
}

const client = new API();

export default client;


// WEBPACK FOOTER //
// ./src/api/index.js